import { loadTranslations } from 'react-redux-i18n'
import { store } from '../../../app/store'

store.dispatch(
  loadTranslations({
    en: {
      ...store.getState().i18n.translations.en,
      cartAndOrders: {
        main: {
          textInvalidPackage:
            'Insufficient current balance. Buy package or choose other payment methods to complete this transaction.',
          noItems: 'Your Cart is Empty ',
          selectAll: 'Select all',
          delete: 'Delete',
          total: 'Total',
          totalPrice: 'Total Price',
          language: 'Language',
          VIETNAMESE: 'Vietnamese',
          ENGLISH: 'English',
          currency: 'Currency',
          reportType: 'Report Type',
          service: 'Service',
          version: 'Version',
          deliveryTime: 'Expected Delivery Time',
          dateCreated: 'Date Created',
          availableData: 'Latest Available FS Data',
          reportingYear: 'Reporting Year',
          unit: 'Unit',
          additional: 'Additional Currency for Financial Statements',
          companyProfile: 'Company profile',
          ownershipGroup: ' Ownership & Group',
          financialStatements: 'Financial Statements',
          source: 'Source',
          typeOfFinancial: 'Type of Financial Statements',
          auditStatus: ' Audit Status',
          method: 'Method',
          score: 'Score',
          industry: 'Industry',
          report: 'report',
          reports: 'reports',
          currentBalance: 'Current Balance',
          orderedNumber: 'Ordered Number',
          buyPackage: 'Buy Package',
          UNCONSOLIDATED: 'Separate',
          CONSOLIDATED: 'Consolidated',
          AUDITED: 'Audited',
          UNAUDITED: 'Unaudited',
          DIRECT: 'Direct',
          INDIRECT: 'Indirect',
          confirmDeleteItem: 'Do you want to delete %{count} item?',
          confirmDeleteItems: 'Do you want to delete %{count} items?',
          variations: 'Variations',
        },
        cart: {
          product: 'Product',
          totalPrice: 'Total Price',
          totalDiscount: 'Total Trade Discount on Product',
          tradeDiscount: 'Trade Discount on Order',
          checkout: 'Check Out',
          includeVAT: 'All prices include VAT',
          selectOrEnter: 'Select or enter code',
          selectDatBlocks: 'Selected Data Block',
          dataBlocks: 'Data Block',
          total: 'Total',
          onRequest: 'On Request Version',
          readyVersion: 'Ready-to-use Version',
          timeCredit: '3-4 days ',
          timeStandard: '4-5 days',
          timeComprehensive: '7-8 days',
          financialSetting: 'Financial Statement Settings',
        },
        orderInformation: {
          backTo: 'Back to Shopping Cart',
          summary: 'Summary of Your Order',
          subTotal: 'Subtotal',
          price: 'Price',
          total: 'Total',
          ruleHead: 'I have read and agreed to',
          ruleLink: ' Terms and Conditions ',
          ruleLinkTitle: 'Terms and Condition',
          ruleLast: 'of FiinGate.com',
          payMethod: 'Payment method',
          package: 'Package',
          bankTransfer: 'Bank Transfers',
          card: 'Card',
          postPaid: 'Post-paid',
          titleInvoice: 'Invoice Receiving information',
          customerName: 'Customer name',
          companyAddress: 'Company Address',
          companyName: 'Company name',
          taxCode: 'Tax Code',
          invoiceEmail: 'Invoice Receiving Email',
          phone: 'Phone',
          note: 'Note: The invoice will be sent to your email once we received bank confirmation.',
          placeOrder: 'Place Order',
          vat: 'All prices include VAT',
          numberOfCompany: 'Number of Companies',
          sortBy: 'Sort by',
          totalInformation: 'Total Information',
          discount: 'Trade Discount',
        },
        tradeDiscount: {
          select: 'Enter voucher code',
          apply: 'Apply',
          cancel: 'Cancel',
          enter: 'Enter your code',
        },
        orderConfirmation: {
          tooltipSimilar: 'Companies in the same industry, size, age, score',
          tooltipMostPopular:
            'Company has the most views, number of purchase reports and number of portfolio was added',
          success: 'You have paid for this order successfully.',
          payment: 'Payment failed',
          check:
            'Your payment amount on the confirmation from Payment Gateway is not matched with transaction value. Need to check',
          process:
            'Your order is being processed. The system will notify the results via your email and system notification.',
          completed: 'Your order is completed.',
          pending:
            'Your order is pending. The system will notify the results via your email and system notification.',
          orderPending:
            'Your order is pending. The system will notify the results via your email and system notification.',
          noti: 'All ordered documents will be stored in Downloaded file (Library) when available.',
          thanks: "Thank you for using FiinGate's services.",
          clickOn: 'Click on Order Management to view detail of this order.',
          goDashboard: 'Go to Dashboard',
          orderManage: 'Order Management',
          maybeLike: 'You may also like',
          similarCompany: 'Similar Companies',
          companyName: 'Company name',
          industry: 'Industry',
          size: 'Company Size',
          year: 'Years in Operation',
          credit: 'Risk Grade',
          performance: 'Performance',
          corporate: 'Corporate Linkage',
          relation: 'Relation',
          theMostCompany: 'The Most Popular Companies',
          purcharsed: 'Purchased Report',
          addPort: 'Added Portfolio',
          views: 'Views',
          currencyOfPayment: 'Currency of Payment',
        },
        transferInformation: {
          title: 'Transfer information',
          bank: 'Bank',
          beneficiaryName: 'Beneficiary Name',
          accountNumber: 'Account Number',
          textNote:
            'Enter correct bank account and account number information or scan the QR code.',
          amount: 'Amount',
          message: 'Message',
          ok: 'OK',
          accountHolder: 'Account Holder',
          bankAddress: 'Bank Address',
          code: 'SWIFT Code',
          scanCode: 'Scan QR Code',
        },
        message: {
          m01: 'Invalid email address',
          m03: 'This field is required',
          m041: 'Insufficient current balance. Buy package or choose other payment methods to complete this transaction.',
          m042: 'You can only apply this payment method when ordering Standard Business Report, Comprehensive Business Report, Credit Business Report',
          m05: 'A report of Y company in orderid abc has been completed',
          m06: 'A report of Y company in orderid abc failed to process.',
          m07: 'Payment failed',
          m08: 'You have paid successfully for this order </br> Your report file is being processed, the system will notify the results via your email and system notification. </br>  All ordered documents will be stored in downloaded file when available.',
          m10: 'Do you want to delete %{count} items?',
          m11: 'You can only apply this payment method when all products have available package.',
          m12: 'Current payment method is not applied for this service.',
          m16: 'Please select product',
          m17: 'You have not selected any items for checkout',
          m19: 'Invalid voucher code',
          m21: 'You have not entered voucher code',
          m20: 'Upgrade to Advance plans or cancel trial to execute transaction',
          tooltip_sc01:
            "This trade discount is offered upon purchasing a specific company's report or a specific report type. The highest available trade discount value will be applied automatically.",
          m22: 'You can only make payment by package when all products are applied current payment method',
        },
        payMethod: {
          PACKAGE: 'Package',
          BANK_TRANSFERS: 'Bank Transfers',
          CARD: 'Card',
          POST_PAID: 'Post-paid',
        },
      },
    },
    vi: {
      ...store.getState().i18n.translations.vi,
      cartAndOrders: {
        main: {
          textInvalidPackage:
            'Số dư hiện tại không đủ. Mua gói hoặc chọn hình thức thanh toán khác để tiếp tục giao dịch.',
          noItems: 'Giỏ hàng của bạn đang trống',
          selectAll: 'Chọn tất cả',
          delete: 'Xóa',
          total: 'Tổng Thanh Toán',
          totalPrice: 'Số Tiền',
          language: 'Ngôn Ngữ',
          VIETNAMESE: 'Tiếng Việt',
          ENGLISH: 'Tiếng Anh',
          currency: 'Tiền Tệ',
          reportType: 'Loại Báo Cáo',
          service: 'Dịch vụ',
          version: 'Phiên Bản',
          deliveryTime: 'Thời Gian Trả Báo Cáo Dự Kiến',
          dateCreated: 'Ngày Hoàn Thành',
          availableData: 'Dữ Liệu BCTC Sẵn Có Gần Nhất',
          reportingYear: 'Năm Báo Cáo',
          unit: 'Đơn Vị',
          additional: 'Tiền Tệ Bổ Sung cho BCTC',
          companyProfile: 'Hồ Sơ Công Ty',
          ownershipGroup: 'Quan hệ & Sở hữu',
          financialStatements: 'Báo Cáo Tài Chính',
          source: 'Nguồn',
          typeOfFinancial: 'Loại Báo Cáo',
          auditStatus: ' Tình trạng kiểm toán',
          method: 'Phương pháp',
          score: 'Điểm số',
          industry: 'Ngành',
          report: 'báo cáo',
          reports: 'cáo cáo',
          currentBalance: 'Số dư hiện tại',
          orderedNumber: 'Số lượng muốn mua',
          buyPackage: 'Mua gói',
          UNCONSOLIDATED: 'Riêng lẻ',
          CONSOLIDATED: 'Hợp nhất',
          AUDITED: 'Kiểm toán',
          UNAUDITED: 'Chưa kiểm toán',
          DIRECT: 'Trực tiếp',
          INDIRECT: 'Gián tiếp',
          confirmDeleteItem: 'Bạn có muốn xóa %{count} mặt hàng?',
          confirmDeleteItems: 'Bạn có muốn xóa %{count} mặt hàng?',
          variations: 'Thay Đổi',
        },
        cart: {
          product: 'Sản Phẩm',
          totalPrice: 'Tổng Tiền',
          totalDiscount: 'Tổng Chiết Khấu Thương Mại cho Sản Phẩm',
          tradeDiscount: 'Chiết Khấu Thương Mại cho Đơn Hàng',
          checkout: 'Mua Hàng',
          includeVAT: 'Giá đã bao gồm VAT',
          selectOrEnter: 'Chọn hoặc nhập mã',
          selectDatBlocks: 'Các Gói Dữ Liệu Được Chọn',
          dataBlocks: 'Các Gói Dữ Liệu',
          total: 'Tổng Thanh Toán',
          onRequest: 'Phiên bản mới',
          readyVersion: 'Phiên bản sẵn có',
          timeCredit: '3-4 ngày',
          timeStandard: '4-5 ngày',
          timeComprehensive: '7-8 ngày',
          financialSetting: 'Cài Đặt Báo Cáo Tài Chính',
        },
        orderInformation: {
          backTo: 'Quay về Giỏ Hàng',
          summary: 'Tóm Tắt Thông Tin Đơn Hàng',
          subTotal: 'Giá sau Chiết Khấu',
          price: 'Giá',
          total: 'Tổng',
          ruleHead: 'Tôi đã đọc và đồng ý với các',
          ruleLink: ' điều khoản và điều kiện ',
          ruleLinkTitle: 'Điều khoản và Điều kiện',
          ruleLast: 'của FiinGate.com',
          payMethod: 'Hình thức thanh toán',
          package: 'Gói',
          bankTransfer: 'Chuyển khoản',
          card: 'Thẻ',
          postPaid: 'Thanh toán sau',
          titleInvoice: 'Thông tin nhận hóa đơn',
          customerName: 'Tên khách hàng',
          companyAddress: 'Địa chỉ công ty',
          companyName: 'Tên công ty',
          taxCode: 'Mã số thuế',
          invoiceEmail: 'Email nhận hóa đơn',
          phone: 'Số điện thoại',
          note: 'Lưu ý: Hóa đơn sẽ được gửi đến email của bạn sau khi chúng tôi nhận được xác nhận của ngân hàng.',
          placeOrder: 'Đặt hàng',
          vat: 'Giá đã bao gồm VAT',
          numberOfCompany: 'Số Lượng Công Ty',
          sortBy: 'Sắp xếp theo',
          totalInformation: 'Trường Thông Tin Kết Quả',
          discount: 'Chiết Khấu',
        },
        tradeDiscount: {
          select: 'Chọn chiết khấu thương mại của bạn',
          apply: 'Áp Dụng',
          cancel: 'Hủy',
          enter: 'Nhập mã của bạn',
        },
        orderConfirmation: {
          tooltipSimilar:
            'Các công ty cùng ngành, quy mô, số năm hoạt động, điểm số',
          tooltipMostPopular:
            'Công ty có lượt xem, số lượng báo cáo được mua và số lượng danh mục đã được thêm vào nhiều nhất',
          success: 'Bạn đã thanh toán thành công cho đơn hàng này.',
          payment: 'Thanh toán thất bại',
          check:
            'Số tiền thanh toán của bạn trên xác nhận từ Cổng Thanh Toán không khớp với giá trị giao dịch. Cần kiểm tra lại.',
          process:
            'Đơn hàng của bạn đang được xử lý. Hệ thống sẽ gửi kết quả xử lý thông qua email và thông báo của hệ thống. ',
          completed: 'Đơn hàng của bạn đã hoàn thành.',
          pending:
            'Đơn hàng của bạn đang chờ xử lý. Hệ thống sẽ gửi kết quả xử lý thông qua email và thông báo của hệ thống.',
          orderPending:
            'Đơn hàng của bạn đang chờ xử lý. Hệ thống sẽ gửi kết quả xử lý thông qua email và thông báo của hệ thống.',
          noti: 'Các báo cáo đã đặt và giao thành công sẽ được lưu trữ trong Tài Liệu Tải Xuống của tính năng Thư Viện',
          thanks: 'Cảm ơn bạn đã sử dụng dịch vụ của FiinGate',
          clickOn: 'Nhấn vào " Quản lý đơn hàng" để xem thông tin chi tiết.',
          goDashboard: 'Chuyển tới Dashboard',
          orderManage: 'Quản Lý Đơn Hàng',
          maybeLike: 'Có thể bạn cũng thích',
          similarCompany: 'Công Ty Tương Tự',
          companyName: 'Tên Công Ty',
          industry: 'Ngành',
          size: 'Quy Mô',
          year: 'Số Năm Hoạt Động',
          credit: 'Rủi Ro Tín Dụng',
          performance: 'Triển Vọng Tăng Trưởng',
          corporate: 'Công Ty Liên Kết',
          relation: 'Quan Hệ',
          theMostCompany: 'Công Ty Phổ Biến Nhất',
          purcharsed: 'Báo Cáo Được Mua',
          addPort: 'Danh Mục',
          views: 'Lượt Xem',
          currencyOfPayment: 'Đồng Tiền Thanh Toán',
        },
        transferInformation: {
          title: 'Thông tin chuyển khoản',
          bank: 'Ngân hàng',
          beneficiaryName: 'Người Thụ Hưởng',
          accountNumber: 'Số Tài Khoản',
          textNote:
            'Nhập đúng thông tin ngân hàng và số tài khoản hoặc quét mã QR.',
          amount: 'Số Tiền',
          message: 'Nội Dung Chuyển Khoản',
          ok: 'Đồng ý',
          accountHolder: 'Chủ Tài Khoản',
          bankAddress: 'Địa Chỉ Ngân Hàng',
          code: 'Mã SWIFT',
          scanCode: 'Quét mã QR',
        },
        message: {
          m01: 'Địa chỉ email không hợp lệ',
          m03: 'Đây là một trường bắt buộc',
          m041: 'Số dư hiện tại không đủ. Mua gói hoặc chọn hình thức thanh toán khác để tiếp tục giao dịch.',
          m042: 'Bạn chỉ có thể áp dụng hình thức thanh toán này khi đặt  Standard Business Report, Comprehensive Business Report, Credit Business Report',
          m05: 'Báo cáo A của công ty Y trong orderId abc đã được hoàn thiện',
          m06: 'Báo cáo A của công ty Y trong orderId abc xử lý thất bại.',
          m07: 'Thanh toán không thành công',
          m08: 'Bạn đã thanh toán thành công cho đơn hàng này </br> File báo cáo của bạn đang được xử lý, hệ thống sẽ gửi kết quả qua email của bạn và qua thông báo trên hệ thống. </br> Mọi báo cáo đã đặt sẽ được lưu trữ trong Downloaded File khi sẵn sàng',
          m10: 'Bạn có muốn xóa %{count} mặt hàng?',
          m11: 'Bạn chỉ được áp dụng hình thức thanh toán này khi mọi sản phẩm có sẵn gói.',
          m12: 'Hình thức thanh toán hiện tại không áp dụng cho dịch vụ này.',
          m16: 'Vui lòng chọn sản phẩm',
          m17: 'Bạn vẫn chưa chọn sản phẩm nào để mua',
          m19: 'Mã voucher không hợp lệ',
          m21: 'Bạn chưa nhập mã voucher',
          m20: 'Nâng cấp tài khoản hoặc hủy dùng thử để thực hiện giao dịch',
          tooltip_sc01:
            'CKTM được áp dụng khi mua báo cáo của một công ty hoặc một loại báo cáo cụ thể. Mức chiết khấu thương mại cao nhất hiện có sẽ được tự động áp dụng.',
          m22: 'Bạn chỉ được thanh toán bằng gói khi mọi sản phẩm được áp dụng hình thức thanh toán này.',
        },
        payMethod: {
          PACKAGE: 'Gói',
          BANK_TRANSFERS: 'Chuyển khoản',
          CARD: 'Thẻ',
          POST_PAID: 'Thanh toán sau',
        },
      },
    },
  }),
)
